import { AxiosResponseHeaders } from 'axios';
import { CardInfoListResponseBody } from '../../../types';
import { Card, CardResponseDTO } from '../entities/Card';

const cardResponseDTOToCardsAdapter = (
  data: CardResponseDTO,
  headers?: AxiosResponseHeaders,
): CardInfoListResponseBody => {
  if (!data.body) {
    throw new Error();
  }

  const { paymentCardsItems: cards } = data.body;
  //TODO: replace hard typed properties with the correct ones as the api is implemented
  return {
    pagination: data.pagination,
    cards: (cards || []).map(
      card =>
        new Card(
          card.cardName,
          '***',
          card.cardProduct.title,
          card.paymentCardIdentifications,
          card.type,
          card.maskedCardNumber,
          card.startDate,
          card.expiryDate,
          card.virtual,
          card.balances,
          card.status,
          card.cardProduct,
          card.cardNetwork,
          card.partyIdentifications,
        ),
    ),
  };
};

export { cardResponseDTOToCardsAdapter };
